import PostListComponent from '../../postAdmin/PostListComponent';

const PostsCustomer = () => {

  return (  
      <PostListComponent
        route={`/dashboard/PostDashboard`}
      />
  ); 
};

export default PostsCustomer;
 